import AuthInterface from './AuthInterface';
import IAuthInterface from './IAuthInterface';

// Singleton instance to maintain backwards compatibility
let authInterfaceInstance: AuthInterface;

export default function authProvider(): IAuthInterface {
  if (authInterfaceInstance) {
    return authInterfaceInstance.getInterface();
  }

  authInterfaceInstance = new AuthInterface();

  return authInterfaceInstance.getInterface();
}
